export const AUTH_TOKEN = 'authSplitTestMiniAppUserData';
export const TEST_COUNT = 'countOfCompletedTests';
